import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Badge from "@material-ui/core/Badge";
import IconButton from "@material-ui/core/IconButton";
import { withRouter } from "react-router-dom";

import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import { useStyles } from "./Count.css";

const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#2ad729",
    color: "black",
  },
}))(Badge);

class BookCount extends Component {
  handleMyBooks = () => {
    this.props.history.push("/mybooks/Author");
  };

  render() {
    const { classes } = this.props;
    return (
      <div onClick={this.handleMyBooks} className={classes.cartStyle}>
        <IconButton disableRipple>
          <StyledBadge max={10} badgeContent={this.props.badgeContent}>
            <LibraryBooksIcon style={{ color: "#eee" }} />
          </StyledBadge>
        </IconButton>
        <label>{this.props.label}</label>
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(BookCount));
